import Vue from 'vue'
import App from '@/App'
import store from '@/store'
import router from '@/router'
import axios from 'axios'
import Tabs from 'vue-tabs-component'
import { GridPlugin } from '@syncfusion/ej2-vue-grids'
import { TooltipPlugin } from '@syncfusion/ej2-vue-popups'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'
import { AccordionPlugin } from '@syncfusion/ej2-vue-navigations'
import { ToastPlugin } from '@syncfusion/ej2-vue-notifications'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faExternalLinkAlt, faServer, faPencil, faUsers, faAlignLeft, faCalendar, faCalendarAlt, faProjectDiagram, faBullhorn, faClock, faChevronLeft, faImage, faLink, faBan, faCode, faFile, faBinoculars, faGlasses, faPlus, faPlusCircle, faChevronDown, faPen, faPaperPlane, faTimes, faCheck, faEdit, faQuestionCircle, faCalendarCheck, faCalendarTimes, faExclamationCircle, faCommentAltCheck, faObjectGroup, faTasks, faSitemap, faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import { faEnvelopeOpenText, faMousePointer, faSync, faGlasses as faGlassesLight, faBinoculars as faBinocularsLight, faBan as faBanLight, faPaperPlane as faPaperPlaneTop, faMinusCircle, faCheck as faCheckLight, faUsers as faLightUsers, faEnvelope, faSave, faArrowFromBottom, faCheckCircle, faWindow, faUserTimes, faRepeat, faBrowser, faExclamationCircle as faLightExclamationCircle, faGripHorizontal, faTasks as faLightTasks } from '@fortawesome/pro-light-svg-icons'
import { faCircle, faEllipsisV } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMoment from 'vue-moment'
import '@/scripts/filters'
import '@/scripts/directive'

// adding jquery as a global variable need this for criteriaPreview.js script in segments
global.jQuery = require('jquery')
const $ = global.jQuery
window.$ = $

library.add(faServer, faUsers, faAlignLeft, faPencil, faPaperPlaneTop, faBanLight, faGlasses, faGlassesLight, faBinocularsLight, faExternalLinkAlt, faCheckLight, faCalendar, faCalendarAlt, faProjectDiagram, faBullhorn, faCircle, faEnvelopeOpenText, faMousePointer, faSync, faMinusCircle, faExclamationCircle, faClock, faChevronLeft, faLightUsers, faEnvelope, faSave, faArrowFromBottom, faCheckCircle, faImage, faLink, faBan, faCode, faFile, faBinoculars, faWindow, faPlus, faPlusCircle, faChevronDown, faPen, faEllipsisV, faPaperPlane, faTimes, faCheck, faEdit, faQuestionCircle, faCalendarCheck, faCalendarTimes, faUserTimes, faRepeat, faBrowser, faLightExclamationCircle, faTasks, faGripHorizontal, faCommentAltCheck, faObjectGroup, faLightTasks, faSitemap, faInfoCircle)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)

Vue.use(Tabs)
Vue.use(GridPlugin)
Vue.use(TooltipPlugin)
Vue.use(DropDownButtonPlugin)
Vue.use(VueMoment)
Vue.use(AccordionPlugin)
Vue.use(ToastPlugin)

window.InitializationWatcher = {
  configLoaded: false
}
window.App = new Vue({
  router,
  store,
  axios,
  render: h => h(App)
})
window.App.$mount('#app')
